import { z } from 'zod';
import { idParamSchema, moneySchema, percentageSchema } from './common';

/**
 * `POST /pricing/quote` — what a set of tests would cost, before anyone is
 * registered.
 *
 * It exists so the standalone calculator screen and the registration form are
 * provably the same arithmetic. Both could call `calculatePricing` in the
 * browser and agree today, but only one of them is the number the server
 * actually books, and a calculator that quietly disagrees with the bill is
 * worse than no calculator.
 *
 * Deliberately a POST rather than a GET: the input is a list of test ids plus
 * three money fields, which is a body, not a query string. Nothing is written.
 */
export const pricingQuoteSchema = z.object({
  test_ids: z.array(idParamSchema).default([]),
  discount_rupees: moneySchema.default(0),
  discount_percentage: percentageSchema.default(0),
  paid: moneySchema.default(0),
});
export type PricingQuoteInput = z.infer<typeof pricingQuoteSchema>;
